import React, {FC, useState} from "react";
import GatewayService from "../../service/GatewayService";
import {useClients} from "../../context/ClientsContext";
import {TimeUtil} from "../../util/TimeUtil";
import {ContractPosition} from "../../models/ContractPosition";
import Calendar from "react-calendar";
import '../Calendar.css';

const CarryForwardComponent: FC = () => {
    const {clients} = useClients();
    const [clientId, setClientId] = useState<string>("");
    const [date, setDate] = useState<string>(TimeUtil.toUIDate(new Date()));
    const [positions, setPositions] = useState<ContractPosition[]>([]);
    const [showCalendar, setShowCalendar] = useState(false);

    function fetchPositions() {
        if (!clientId || !date) {
            return;
        }
        GatewayService.getCarryForwardPositions(clientId, date)
            .then(setPositions)
            .catch(console.error);
    }

    const handleDateChange = (newDate: Date | null | [Date | null, Date | null]) => {
        if (newDate instanceof Date) {
            setDate(TimeUtil.toUIDate(newDate));
            setShowCalendar(false);
        }
    };

    return (
        <div>
            <h2>Carry Forward Positions</h2>
            <select value={clientId} onChange={e => setClientId(e.target.value)}>
                <option value="">Select Client</option>
                {clients.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
            <input type="text" value={date} onChange={e => setDate(e.target.value)}/>
            <button onClick={() => setShowCalendar(s => !s)}>{showCalendar ? 'Hide' : 'Show'} Calendar</button>
            {showCalendar && <Calendar
                onChange={handleDateChange}
                value={TimeUtil.parseUIDate(date) || new Date()}
            />}
            <button onClick={fetchPositions}>Fetch</button>

            <table className="full">
                <thead>
                <tr>
                    <th>Symbol</th>
                    <th>Exchange</th>
                    <th>Quantity</th>
                    <th>Strike</th>
                    <th>Instrument Type</th>
                    <th>Future</th>
                    <th>Client</th>
                </tr>
                </thead>
                <tbody>
                {positions.map((pos, index) => (
                    <tr key={index}>
                        <td>{pos.tradingsymbol}</td>
                        <td>{pos.exchange}</td>
                        <td>{pos.quantity}</td>
                        <td>{pos.strike}</td>
                        <td>{pos.instrumentType}</td>
                        <td>{pos.correspondingFuture}</td>
                        <td>{pos.clientId}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}

export default CarryForwardComponent;
